import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { FaHome, FaBars, FaInfoCircle, FaPlus } from "react-icons/fa";
import { signOut } from 'firebase/auth';
import { auth } from '../../components/firebaseConfig';
import toast from 'react-hot-toast';
import AHome from './minifiedPages/AHome';
import Anaicerik from './minifiedPages/Anaicerik';
import Kullanici from './minifiedPages/Kullanici';
import Etkinlik from './minifiedPages/Etkinlik';
import Odemefatura from './minifiedPages/Odemefatura';
import Haberler from './minifiedPages/Haberler';
import Otobus from './minifiedPages/Otobus';
import Anket from './minifiedPages/Anket';
import Bildirimler from './minifiedPages/Bildirimler';
import Ayarlar from './minifiedPages/Ayarlar';
import Sikayetler from './minifiedPages/Sikayetler';
import Dokumanlar from './minifiedPages/Dokumanlar';
import Veriler from './minifiedPages/Veriler';
import Header from '../requirecomp/Header';
import Story from './minifiedPages/Story';
import Ustpage from './minifiedPages/Ustpage';
import { Bars3Icon, XMarkIcon, HomeIcon, CogIcon, UserIcon, ChevronDownIcon, ExclamationCircleIcon, CalendarDaysIcon, CreditCardIcon, TruckIcon, ChartBarIcon, UserGroupIcon, BellIcon, DocumentIcon
} from '@heroicons/react/24/outline';
import Appsettings from './minifiedPages/Appsettings';

function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userClaims, setUserClaims] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [usersMenuOpen, setUsersMenuOpen] = useState(false);
  useEffect(() => {
    const fetchUserClaims = async () => {
      const user = auth.currentUser;
      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        setUserClaims(idTokenResult.claims);
      }
    };

    fetchUserClaims();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success("Çıkış Yapıldı!");
    } catch (error) {
      toast.error("Çıkış yapılamadı. Lütfen tekrar deneyin.");
      console.error("Çıkış Hatası:", error.message);
    }
  };

  return (
    <Router>
    <div className="flex h-screen bg-white overflow-y-scroll">
        {/* Sidebar */}
        <div
  className={`fixed inset-y-0 left-0 z-30 flex flex-col p-4 transition-all duration-300 bg-white shadow-lg ${
    sidebarOpen ? "w-56" : "w-16"
  }`}
>
  <button
    onClick={() => setSidebarOpen(!sidebarOpen)}
    className="mb-4 self-start"
  >
    {sidebarOpen ? (
      <XMarkIcon
        className="w-6 h-6"
        style={{
          marginLeft: 5,
        }}
      />
    ) : (
      <Bars3Icon
        className="w-6 h-6"
        style={{
          marginLeft: 5,
        }}
      />
    )}
  </button>
  <nav className="flex flex-col items-start space-y-4 overflow-y-auto h-full scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
    {[
      { to: "/home", label: "Anasayfa", icon: HomeIcon },
      { to: "/sikayetler", label: "Şikayetler & Görüşler", icon: ExclamationCircleIcon },
      { to: "/kullanicilar", label: "Kullanıcı Yönetimi", icon: UserIcon },
      { to: "/odemeler", label: "Ödemeler", icon: CreditCardIcon },
      { to: "/otobus", label: "Otobüs Yönetimi", icon: TruckIcon },
      { to: "/anket", label: "Anket Yönetimi", icon: ChartBarIcon },
      { to: "/bildirimler", label: "Bildirim Yönetimi", icon: BellIcon },
      { to: "/veriler", label: "Uygulama Verileri", icon: DocumentIcon },
      { to: "/appsettings", label: "Uygulama Ayarları", icon: CogIcon },
    ].map(({ to, label, icon: Icon }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          `flex items-center w-full p-2 text-gray-700 rounded-lg hover:bg-gray-200 ${
            isActive ? "bg-gray-200" : ""
          }`
        }
      >
        <Icon className="w-6 h-6" />
        {sidebarOpen && <span className="ml-2 text-sm">{label}</span>}
      </NavLink>
    ))}
    <hr className="w-full border-gray-300" />
    <div className="w-full">
      <button
        onClick={() => setUsersMenuOpen(!usersMenuOpen)}
        className="flex items-center w-full p-2 text-gray-700 rounded-lg hover:bg-gray-200"
      >
        <UserIcon className="w-6 h-6" />
        {sidebarOpen && (
          <span className="flex-grow ml-2 flex justify-between items-center text-sm">
            Uygulama İçerik
            <ChevronDownIcon
              className={`w-5 h-5 transition-transform ${
                usersMenuOpen ? "rotate-180" : ""
              }`}
            />
          </span>
        )}
      </button>
      {usersMenuOpen && sidebarOpen && (
        <div className="pl-8 mt-2 space-y-2">
          {[
            { to: "/ana-icerik", label: "Ana İçerik" },
            { to: "/haberler", label: "Haberler" },
            { to: "/etkinlik", label: "Etkinlikler" },
            { to: "/ustpage", label: "Üst görsel" },
            { to: "/story", label: "Story(Hikaye)" },
            { to: "/bos3", label: "Boş" },
          ].map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center w-full p-2 text-gray-700 rounded-lg hover:bg-gray-200 text-sm ${
                  isActive ? "bg-gray-300" : ""
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  </nav>
</div>

        {/* Main Content */}
        <div
          className={`flex flex-col flex-1 min-h-screen transition-all duration-300 ${
            sidebarOpen ? 'ml-56' : 'ml-16'
          }`}
        >
          {/* Header */}
          <Header
          userClaims={userClaims}
          dropdownOpen={dropdownOpen}
          setDropdownOpen={setDropdownOpen}
          handleLogout={handleLogout}
        />

          {/* Router Content */}
          <main className="flex-grow p-4 pt-4">
            <Routes>
              <Route path="/" element={<AHome />} />
              <Route path="/home" element={<AHome />} />
              <Route path="/ana-icerik" element={<Anaicerik />} />
              <Route path="/kullanicilar" element={<Kullanici />} />
              <Route path="/Ustpage" element={<Ustpage />} />
              <Route path="/story" element={<Story />} />
              <Route path="/etkinlik" element={<Etkinlik />} />
              <Route path="/haberler" element={<Haberler />} />
              <Route path="/odemefatura" element={<Odemefatura />} />
              <Route path="/anket" element={<Anket />} />
              <Route path="/otobus" element={<Otobus />} />
              <Route path="/settings" element={<Ayarlar />} />
              <Route path="/bildirimler" element={<Bildirimler />} />
              <Route path="/sikayetler" element={<Sikayetler />} />
              <Route path="/dokumanlar" element={<Dokumanlar />} />
              <Route path="/kullanim-kilavuzu" element={<Dokumanlar />} />
              <Route path="/appsettings" element={<Appsettings />} />
              <Route path="/veriler" element={<Veriler />} />
              <Route path="*" element={<AHome />} />
            </Routes>
          </main>




          <div>

            {/* Masaüstü Footer */}
            <footer className="bg-slate-100 text-gray-600 hidden md:block fixed bottom-0 left-0 w-full">
              <div className="flex justify-between max-w-7xl mx-auto px-4">
                <div className="flex-1">
                  <p className="text-xs font-medium">© Copyright 2024 </p>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-medium">İletişim: info@peronmedya.com</p>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-medium">Telefon: +90 539 548 59 67</p>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-medium">Tüm Hakları Saklıdır!</p>
                </div>
              </div>
            </footer>

            <div
              className="bg-white fixed bottom-0 left-0 w-full md:hidden flex justify-around items-center border-t border-gray-300 shadow-lg py-2"
              style={{ zIndex: 2322 }}
            >
              {/* Sol İlk İkon */}
              <button className="flex flex-col items-center hover:text-gray-900 active:text-gray-900">
                <FaHome className="w-4 h-4 text-gray-600" />
                <span className="text-xs font-medium">Anasayfa</span>
              </button>

              {/* Sol Orta İkon */}
              <button className="flex flex-col items-center hover:text-gray-900 active:text-gray-900">
                <FaBars className="w-3 h-4 text-gray-600" />
                <span className="text-xs font-medium">Menü</span>
              </button>

              {/* Sağ Orta İkon */}
              <button className="flex flex-col items-center hover:text-gray-900 active:text-gray-900">
                <FaInfoCircle className="w-4 h-4 text-gray-600" />
                <span className="text-xs font-medium">Hakkımızda</span>
              </button>

              {/* Sağ İlk İkon */}
              <button className="flex flex-col items-center hover:text-gray-900 active:text-gray-900">
                <FaPlus className="w-4 h-4 text-gray-600" />
                <span className="text-xs font-medium">Hizmetler</span>
              </button>
            </div>







          </div>


        </div>
      </div>
    </Router>
  );
}

export default Dashboard;
